import React from 'react';

const FieldDescription = ({description}) => {
    return (
        <div className="mv1 f6 o-60">{description}</div>
    );
};

export default FieldDescription;